import { render, staticRenderFns } from "./mailPaperMaterials.vue?vue&type=template&id=d357e01a&"
import script from "./mailPaperMaterials.vue?vue&type=script&lang=js&"
export * from "./mailPaperMaterials.vue?vue&type=script&lang=js&"
import style0 from "./mailPaperMaterials.vue?vue&type=style&index=0&id=d357e01a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports